// Keycloak.js
import Keycloak from 'keycloak-js';

// Конфигурация Keycloak
const keycloakConfig = {
  url: 'https://key.tesla.udmed.ru/', // URL вашего Keycloak-сервера
  realm: 'rmiac', // Ваш реалм
  clientId: 'certificates-service', // Ваш ID клиента
  checkLoginIframe: true, // включить iframe-based refresh
  checkLoginIframeInterval: 30, // проверять каждые 30 сек
  onLoad: 'login-required', // по умолчанию, переопределяется в App.tsx
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;